<pc-error-popup
  [btnPadding]="35"
  [buttonsContainerFlexDirection]="isDesktop() ? 'row' : 'column'"
  [buttonSecondaryInnerHtmlText]="smallPopup() ? (secondaryButtonText() | translate) : ''"
  [buttonText]="buttonText() | translate"
  [contentClass]="'dynamic-height'"
  [desktopImgPath]="desktopImgPath()"
  [imgAlt]="'refer_to_sales'"
  [information]="smallPopup() ? (textInformation() | translate) : ''"
  [isButtonsPartOfScrollingContainer]="!smallPopup()"
  [isCloseIcon]="isCloseIcon()"
  [isSecondaryBtnTextImageReverseOrder]="true"
  [mobileImgPath]="mobileImgPath()"
  [secondaryBtnMinWidth]="isDesktop() ? 250 : 0"
  [secondaryBtnPadding]="35"
  [secondaryButtonIcon]="PcButtonIcon.BLUE_PHONE"
  [secondaryButtonType]="PcButtonType.blur"
  [subInformation]="smallPopup() ? (textSubInformation() | translate) : ''"
  [submitButtonIcon]="PcButtonIcon.RIGHT_ARROW"
  [title]="title() | translate"
  (closeErrorDialog)="closeButton()"
  (closeWithSubmit)="closeWithSubmit()"
>
  <section class="main-section-completed" section-content tabindex="0">
    @if (!smallPopup()) {
      <pc-responsive-abstract-card [color]="'secondary'" [size]="'item-card'">
        <div class="form-completed">
          <pc-icon [icon]="PcIcon.FORM_COMPLETED" [size]="'xlarge'"></pc-icon>
          <h1 class="headline3-secondary-title">{{ textInformation() | translate }}</h1>
          <span class="body-large">{{ textSubInformation() | translate }} </span>
        </div>
      </pc-responsive-abstract-card>
      <pc-summary-collapsible-card [title]="summaryCardTitle()">
        <ng-container
          *ngTemplateOutlet="
            summaryTemplate();
            context: { isEmailSection: 'false', showBrokerFeeIfBrokerSalesProcess: 'false', $implicit: 'false' }
          "
        ></ng-container>
      </pc-summary-collapsible-card>
    }
  </section>
</pc-error-popup>
